import { render, staticRenderFns } from "./homeProducts.vue?vue&type=template&id=9ca4a5b2&scoped=true&"
import script from "./homeProducts.vue?vue&type=script&lang=js&"
export * from "./homeProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ca4a5b2",
  null
  
)

export default component.exports